"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ModeDropdown_1 = __importDefault(require("./Dropdown/ModeDropdown"));
const MenuIcon_1 = __importDefault(require("./MenuIcon/MenuIcon"));
const ModeSelector = (props) => {
    const numberOfItems = props.availableModes.length;
    if (numberOfItems <= 1) {
        return null;
    }
    if (props.collapsed) {
        return renderCollapsedModeSelector();
    }
    return (React.createElement("div", { className: "mode-selector" }, props.availableModes.map((m) => (React.createElement("a", { className: m.mode === props.currentMode ? 'active-mode' : '', key: m.mode, href: m.url },
        React.createElement(MenuIcon_1.default, { type: "MODE", icon: m.icon }),
        numberOfItems > 3 ? null : React.createElement("p", null, m.title))))));
    function renderCollapsedModeSelector() {
        return (React.createElement("div", { className: "mode-selector-collapsed" },
            React.createElement(ModeDropdown_1.default, { currentMode: props.currentMode, availableModes: props.availableModes })));
    }
};
exports.default = ModeSelector;
//# sourceMappingURL=ModeSelector.js.map